import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("AI Chat controller connected")
  }
  
  updateModels() {
    alert("updateModels method is called!")
    console.log("updateModels method called")
  }
}